import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "text-title-underline" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ページが見つかりませんでした。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.page)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.page.title), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: "v-html whitespace-pre-wrap mb-6",
                      innerHTML: _ctx.page.body
                    }, null, 8, _hoisted_3)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}